export const categories = [
  { slug: "all", name: "全部", icon: "ri-apps-line" },
  { slug: "romance", name: "恋爱", icon: "ri-heart-line" },
  { slug: "fantasy", name: "奇幻", icon: "ri-magic-line" },
  { slug: "action", name: "动作", icon: "ri-flashlight-line" },
  { slug: "thriller", name: "悬疑", icon: "ri-search-eye-line" },
  { slug: "comedy", name: "搞笑", icon: "ri-emotion-laugh-line" },
  { slug: "daily", name: "日常", icon: "ri-sun-line" },
  { slug: "drama", name: "剧情", icon: "ri-film-line" },
  { slug: "historical", name: "古风", icon: "ri-ancient-gate-line" },
];

export const manhwas = [
  {
    id: 1,
    slug: "my-love-from-another-star",
    title: "来自星星的爱",
    author: "金秀贤",
    category: "romance",
    categoryName: "恋爱",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20comic%20cover%2C%20beautiful%20couple%20under%20starry%20night%20sky%2C%20soft%20warm%20lighting%2C%20dreamy%20atmosphere%2C%20clean%20illustration%20with%20minimal%20background%2C%20anime%20art%20style%2C%20emotional%20romantic%20scene&width=400&height=560&seq=manhwa-cover-01&orientation=portrait",
    description: "一个来自另一个世界的他，一段跨越星际的爱恋。当平凡女孩遇上神秘外星来客，命运的齿轮开始转动...",
    rating: 4.8,
    views: 1250000,
    chapters: 87,
    status: "连载中",
    updatedAt: "2026-08-03",
    tags: ["恋爱", "奇幻", "校园"],
    featured: true,
  },
  {
    id: 2,
    slug: "sword-of-destiny",
    title: "命运之剑",
    author: "李敏镐",
    category: "action",
    categoryName: "动作",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20comic%20cover%2C%20warrior%20holding%20glowing%20sword%20in%20epic%20battle%20pose%2C%20dramatic%20lighting%20with%20dark%20background%2C%20anime%20illustration%20style%2C%20powerful%20dynamic%20composition&width=400&height=560&seq=manhwa-cover-02&orientation=portrait",
    description: "在剑与魔法的世界中，少年握紧命运之剑，踏上复仇与救赎的征程。每一场战斗，都是对命运的挑战。",
    rating: 4.6,
    views: 980000,
    chapters: 124,
    status: "连载中",
    updatedAt: "2026-08-04",
    tags: ["动作", "奇幻", "冒险"],
    featured: true,
  },
  {
    id: 3,
    slug: "secret-garden-blossom",
    title: "秘密花园",
    author: "朴敏英",
    category: "romance",
    categoryName: "恋爱",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20comic%20cover%2C%20beautiful%20girl%20in%20flower%20garden%20with%20soft%20sunlight%2C%20pastel%20color%20palette%2C%20romantic%20dreamy%20atmosphere%2C%20anime%20art%20style%2C%20delicate%20illustration&width=400&height=560&seq=manhwa-cover-03&orientation=portrait",
    description: "隐藏在城市角落的秘密花园，两个陌生人因花结缘。治愈系的爱情故事，温暖每一个读者的心。",
    rating: 4.9,
    views: 1560000,
    chapters: 56,
    status: "已完结",
    updatedAt: "2026-07-15",
    tags: ["恋爱", "治愈", "都市"],
    featured: true,
  },
  {
    id: 4,
    slug: "phantom-detective",
    title: "幽灵侦探",
    author: "郑宇成",
    category: "thriller",
    categoryName: "悬疑",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20thriller%20comic%20cover%2C%20detective%20in%20trench%20coat%20standing%20in%20shadow%20alley%2C%20noir%20atmosphere%2C%20dark%20rainy%20street%2C%20suspenseful%20mood%2C%20anime%20illustration%20style&width=400&height=560&seq=manhwa-cover-04&orientation=portrait",
    description: "能看见幽灵的侦探，破解一桩桩离奇案件。当超自然力量介入现实，真相往往比想象中更加震撼。",
    rating: 4.7,
    views: 1320000,
    chapters: 73,
    status: "连载中",
    updatedAt: "2026-08-02",
    tags: ["悬疑", "超自然", "推理"],
    featured: false,
  },
  {
    id: 5,
    slug: "dragon-academy-life",
    title: "龙之学园",
    author: "刘在石",
    category: "fantasy",
    categoryName: "奇幻",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20comic%20cover%2C%20magical%20academy%20with%20dragon%20flying%20in%20sky%2C%20fantasy%20world%20castle%2C%20bright%20vibrant%20colors%2C%20anime%20art%20style%2C%20adventure%20theme&width=400&height=560&seq=manhwa-cover-05&orientation=portrait",
    description: "普通人被选入培养龙骑士的魔法学园，在这里他将遇见志同道合的伙伴，揭开学园隐藏千年的秘密。",
    rating: 4.5,
    views: 1100000,
    chapters: 95,
    status: "连载中",
    updatedAt: "2026-08-03",
    tags: ["奇幻", "校园", "冒险"],
    featured: false,
  },
  {
    id: 6,
    slug: "laugh-out-loud-family",
    title: "爆笑一家人",
    author: "姜虎东",
    category: "comedy",
    categoryName: "搞笑",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20comic%20cover%2C%20funny%20family%20with%20exaggerated%20expressions%2C%20colorful%20bright%20illustration%2C%20humorous%20anime%20style%2C%20playful%20atmosphere%2C%20cartoonish%20characters&width=400&height=560&seq=manhwa-cover-06&orientation=portrait",
    description: "四个性格迥异的家庭成员，每天的日常生活就是最棒的喜剧。搞笑又温馨，笑中带泪的家庭故事。",
    rating: 4.4,
    views: 890000,
    chapters: 142,
    status: "连载中",
    updatedAt: "2026-08-04",
    tags: ["搞笑", "家庭", "日常"],
    featured: false,
  },
  {
    id: 7,
    slug: "morning-coffee-routine",
    title: "清晨的咖啡",
    author: "金泰熙",
    category: "daily",
    categoryName: "日常",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20comic%20cover%2C%20girl%20enjoying%20coffee%20at%20cafe%20window%20seat%2C%20warm%20morning%20sunlight%2C%20cozy%20relaxed%20atmosphere%2C%20clean%20anime%20illustration%20style%2C%20simple%20elegant%20composition&width=400&height=560&seq=manhwa-cover-07&orientation=portrait",
    description: "每天早上的一杯咖啡，串联起都市男女的日常故事。慢节奏的生活漫画，在忙碌中寻找片刻宁静。",
    rating: 4.3,
    views: 760000,
    chapters: 68,
    status: "已完结",
    updatedAt: "2026-06-20",
    tags: ["日常", "治愈", "都市"],
    featured: false,
  },
  {
    id: 8,
    slug: "crown-of-tears",
    title: "泪之皇冠",
    author: "宋慧乔",
    category: "drama",
    categoryName: "剧情",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20comic%20cover%2C%20royal%20queen%20with%20crown%20in%20palace%20setting%2C%20dramatic%20emotional%20expression%2C%20rich%20dark%20tone%20illustration%2C%20historical%20anime%20art%20style%2C%20elegant%20composition&width=400&height=560&seq=manhwa-cover-08&orientation=portrait",
    description: "王朝更迭，权力纷争。一个女子如何在血雨腥风中守护挚爱，在权谋与真情之间做出抉择。",
    rating: 4.8,
    views: 1450000,
    chapters: 110,
    status: "连载中",
    updatedAt: "2026-08-01",
    tags: ["剧情", "古风", "权谋"],
    featured: true,
  },
  {
    id: 9,
    slug: "moonlight-palace",
    title: "月下宫殿",
    author: "李钟硕",
    category: "historical",
    categoryName: "古风",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20comic%20cover%2C%20traditional%20Korean%20palace%20under%20moonlight%2C%20hanbok%20characters%2C%20elegant%20night%20scene%2C%20anime%20illustration%20with%20traditional%20elements%2C%20refined%20composition&width=400&height=560&seq=manhwa-cover-09&orientation=portrait",
    description: "朝鲜时代，月光下的宫殿里，一段被遗忘的传奇正徐徐展开。历史与想象交织，呈现最美古风画卷。",
    rating: 4.6,
    views: 1050000,
    chapters: 82,
    status: "连载中",
    updatedAt: "2026-07-30",
    tags: ["古风", "历史", "爱情"],
    featured: false,
  },
  {
    id: 10,
    slug: "neon-seoul-nights",
    title: "霓虹首尔夜",
    author: "金秀智",
    category: "drama",
    categoryName: "剧情",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20modern%20drama%20comic%20cover%2C%20Seoul%20city%20night%20with%20neon%20lights%2C%20stylish%20young%20characters%2C%20urban%20noir%20atmosphere%2C%20anime%20art%20style%2C%20contemporary%20cool%20illustration&width=400&height=560&seq=manhwa-cover-10&orientation=portrait",
    description: "在首尔霓虹闪烁的夜晚，一群年轻人的梦想与爱情交织。都市生活的酸甜苦辣，尽在这座不夜城。",
    rating: 4.5,
    views: 920000,
    chapters: 64,
    status: "连载中",
    updatedAt: "2026-08-03",
    tags: ["剧情", "都市", "青春"],
    featured: false,
  },
  {
    id: 11,
    slug: "magic-bakery-tales",
    title: "魔法面包坊",
    author: "裴秀智",
    category: "fantasy",
    categoryName: "奇幻",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20comedy%20comic%20cover%2C%20magical%20bakery%20with%20floating%20pastries%20and%20sparkles%2C%20cute%20warm%20atmosphere%2C%20whimsical%20anime%20illustration%2C%20cozy%20shop%20interior&width=400&height=560&seq=manhwa-cover-11&orientation=portrait",
    description: "一家隐藏在巷子里的魔法面包坊，每个面包都蕴含神奇魔力。吃下面包的人，会获得意想不到的超能力！",
    rating: 4.7,
    views: 870000,
    chapters: 48,
    status: "连载中",
    updatedAt: "2026-08-04",
    tags: ["奇幻", "美食", "治愈"],
    featured: true,
  },
  {
    id: 12,
    slug: "office-romance-101",
    title: "办公室恋爱守则",
    author: "韩艺瑟",
    category: "romance",
    categoryName: "恋爱",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20romance%20comic%20cover%2C%20stylish%20office%20workers%20in%20modern%20office%20setting%2C%20romantic%20tension%2C%20clean%20professional%20anime%20style%2C%20bright%20natural%20lighting&width=400&height=560&seq=manhwa-cover-12&orientation=portrait",
    description: "新入职的菜鸟和冷酷上司之间的办公室恋情。在公司禁止恋爱的规定下，两人的秘密关系步步惊心。",
    rating: 4.4,
    views: 750000,
    chapters: 55,
    status: "连载中",
    updatedAt: "2026-07-28",
    tags: ["恋爱", "职场", "喜剧"],
    featured: false,
  },
];

export const heroManhwas = manhwas.filter((m) => m.featured);

export const latestManhwas = [...manhwas].sort(
  (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
);

export const popularManhwas = [...manhwas].sort((a, b) => b.views - a.views);

export const topRatedManhwas = [...manhwas].sort((a, b) => b.rating - a.rating);

export const getManhwasByCategory = (categorySlug: string) => {
  if (categorySlug === "all") return manhwas;
  return manhwas.filter((m) => m.category === categorySlug);
};

export const getManhwaBySlug = (slug: string) => {
  return manhwas.find((m) => m.slug === slug) || null;
};